import { axiosClient } from './AxiosClient'

function listGallery(page, size, callback, errorCallback){
    let url = "/image/album/admin/list";

    var bodyData = new FormData();
    bodyData.append("page", page);
    bodyData.append("size", size);
    bodyData.append("album_for", "News")
    bodyData.append("building_id", localStorage.getItem('building_id'))

    axiosClient.post(url, bodyData)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function createAlbum(albumName, description, purpose, callback, errorCallback){
    let url = "/image/album/admin/create";

    var bodyData = new FormData();
    bodyData.append("album_name", albumName)
    bodyData.append("album_for", purpose)
    bodyData.append("description", description)
    bodyData.append("building_id", localStorage.getItem('building_id'))

    axiosClient.post(url, bodyData)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function viewAlbum(albumId, callback, errorCallback){
    let url = "/image/album/admin/view";

    var bodyData = new FormData()
    bodyData.append("album_id", albumId)

    axiosClient.post(url, bodyData)
    .then((response)=>{
        let data = response.data
        callback(data)
    })
    .catch((error)=>{
        console.log(error)
        errorCallback(error)
    })
}

function editAlbum(albumId, albumName, description, callback, errorCallback){
    let url = "/image/album/admin/edit";

    var bodyData = new FormData()
    bodyData.append("album_id", albumId)
    bodyData.append("album_name", albumName)
    bodyData.append("description", description)

    axiosClient.post(url, bodyData)
    .then(()=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function deleteAlbum(albumId, callback, errorCallback){
    let url = "/image/album/admin/delete";

    var bodyData = new FormData()
    bodyData.append("album_id", albumId)

    axiosClient.post(url, bodyData)
    .then(()=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function uploadToAlbum(albumId, file, callback, errorCallback){
    let url = "/image/admin/upload"

    var bodyData = new FormData()
    bodyData.append("album_id", albumId)
    bodyData.append("image", file)

    axiosClient.post(url, bodyData)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

function deleteImageFromAlbum(imageId, callback, errorCallback){
    let url = "/image/delete"

    var bodyData = new FormData()
    bodyData.append("image_id", imageId)

    axiosClient.post(url, bodyData)
    .then((response)=>{
        callback()
    })
    .catch((error)=>{
        errorCallback(error)
    })
}

export { listGallery, createAlbum, viewAlbum, editAlbum, deleteAlbum, uploadToAlbum, deleteImageFromAlbum }